import React from "react";
import "./BadgeShape.css";

/** One badge design per round position, cycling if there are more rounds than badges — shared
 * between the in-game "Stamp earned" celebration (CheckpointGame.jsx) and the finale passport
 * grid (thankyou.jsx) so the same round always gets the same badge in both places. */
export const BADGES = [
  { icon: "fa-star", shape: "hexagon", bg: "#fef3c7", fg: "#f6a821" },
  { icon: "fa-compass", shape: "circle", bg: "#dbeafe", fg: "#2563eb" },
  { icon: "fa-camera", shape: "squircle", bg: "#fce7f3", fg: "#e75a8f" },
  { icon: "fa-bolt", shape: "hexagon", bg: "#fee2e2", fg: "#ef4444" },
  { icon: "fa-map", shape: "hexagon", bg: "#ede9fe", fg: "#8b5cf6" },
  { icon: "fa-trophy", shape: "octagon", bg: "#fef9c3", fg: "#eab308" },
];

export function badgeForRound(roundIndex) {
  const i = Number.isFinite(roundIndex) && roundIndex >= 0 ? roundIndex : 0;
  return BADGES[i % BADGES.length];
}

const SHAPE_POINTS = {
  hexagon: "30,3 54,16.5 54,43.5 30,57 6,43.5 6,16.5",
  octagon: "18,3 42,3 57,18 57,42 42,57 18,57 3,42 3,18",
};

export function BadgeShape({ shape, earned, bg, fg, icon }) {
  const stroke = fg;
  const fill = earned ? bg : "none";
  const strokeOpacity = earned ? 1 : 0.45;
  const shapeProps = { fill, stroke, strokeWidth: 2, strokeDasharray: "5 4", strokeOpacity };

  let shapeEl;
  if (shape === "circle") {
    shapeEl = <circle cx="30" cy="30" r="27" {...shapeProps} />;
  } else if (shape === "squircle") {
    shapeEl = <rect x="3" y="3" width="54" height="54" rx="16" {...shapeProps} />;
  } else {
    shapeEl = <polygon points={SHAPE_POINTS[shape] || SHAPE_POINTS.hexagon} {...shapeProps} />;
  }

  return (
    <div className="fp-badge-shape">
      <svg viewBox="0 0 60 60" width="100%" height="100%" preserveAspectRatio="xMidYMid meet">
        {shapeEl}
      </svg>
      <i className={`fa-solid ${icon}`} style={{ color: earned ? fg : "#c9c2b6" }} />
    </div>
  );
}
